import React from 'react';
import PropTypes from 'prop-types';

import OEDropdown from '../../controls/oe-dropdown';
import {OEObjectModelValueEditDecls} from '../oe-object-model-value-edit-model';
import OEObjectModelValueCell from './oe-object-model-value-cell';
import OEToolbox from '../../../../lib/tools/oe-toolbox';

export default class OEObjectModelDropdownCell extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            dropdownEntries: this.getDropdownEntries()
        };

        this.onClick = this.onClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(!OEToolbox.shallowEqual(nextProps.entries, this.props.entries, true)) {
            this.updateDropdownEntries(nextProps);
        }
    }

    getDropdownEntries(props)   {
        props = props || this.props;
        return props.entries.map((e, index) => {return {key: index, content: e.label}; });
    }

    updateDropdownEntries(props)    {
        this.setState({dropdownEntries: this.getDropdownEntries(props)});
    }

    render()    {
        let choosenKey = this.props.entries.findIndex(e => e.value === this.props.value);
        let choosenEntry = choosenKey >= 0 ? this.props.entries[choosenKey] : undefined;

        if(choosenKey < 0 && this.props.defaultDropdownTitle)    {
            let defaultDropdownTitleIndex = this.props.entries.findIndex(e => e.label === this.props.defaultDropdownTitle);
            if(defaultDropdownTitleIndex >= 0)   choosenKey = defaultDropdownTitleIndex;
        }

        return (
            <OEObjectModelValueCell {...this.props}>
                <OEDropdown
                    title={choosenEntry ? choosenEntry.label : this.props.defaultDropdownTitle}
                    disabled={this.props.disabled}
                    chosenKey={choosenKey}
                    entries={this.state.dropdownEntries}
                    onClick={this.onClick}
                />
            </OEObjectModelValueCell>
        );
    }

    onClick(key, userData, index)    {
        if(typeof(key) !== 'number' || key < 0 || key >= this.props.entries.length) return;
        let value = this.props.entries[key].value;
        if(value === this.props.value) return;
        if(this.props.onChange)   this.props.onChange(this, this.props.name, value);
    }
};

OEObjectModelDropdownCell.defaultProps = Object.assign({
    disabled:                   false,
    entries:                    [],
    defaultDropdownTitle:       ''
}, OEObjectModelValueCell.defaultProps);

OEObjectModelDropdownCell.propTypes = Object.assign({
    disabled:                   PropTypes.bool,
    entries:                    OEObjectModelValueEditDecls.dropDownCellEntries,
    defaultDropdownTitle:       PropTypes.string,
    value:                      PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}, OEObjectModelValueCell.propTypes);